<template>
  <div class="sms-status-container">
    <!-- Sent icon (shows after SMS sent) -->
    <span
      v-if="smsStatus === 'sent' || smsStatus === 'confirmed'"
      class="sms-icon"
      :class="{ 'sms-icon-confirmed': smsStatus === 'confirmed' }"
      :title="smsStatus === 'confirmed' ? 'Potwierdzono' : 'Wysłano SMS'"
    >
      <font-awesome-icon
        :icon="smsStatus === 'confirmed' ? 'check' : 'paper-plane'"
      />
    </span>
    <!-- Action button -->
    <button
      v-if="smsStatus !== 'confirmed'"
      class="sms-btn"
      :class="statusClass"
      :disabled="disabled"
      @click="handleClick"
    >
      {{ statusText }}
    </button>
    <!-- Reset button for admin -->
    <button
      v-if="isAdmin && smsStatus !== 'pending'"
      class="reset-btn"
      :disabled="disabled"
      @click="handleReset"
      title="Resetuj status SMS"
    >
      <font-awesome-icon icon="times" />
    </button>
  </div>
</template>

<script>
import { computed } from 'vue';
import store from '@/store';

export default {
  name: 'SmsStatusButton',

  props: {
    smsStatus: {
      type: String,
      default: 'pending',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['status-change'],

  setup(props, { emit }) {
    const statusTexts = {
      pending: 'Wyślij SMS',
      sent: 'Potwierdź',
    };

    const statusText = computed(() => statusTexts[props.smsStatus] || 'Wyślij SMS');

    const statusClass = computed(() => ({
      'sms-pending': props.smsStatus === 'pending',
      'sms-sent': props.smsStatus === 'sent',
    }));

    const isAdmin = computed(() => store.getters.isAdmin);

    function handleClick() {
      const nextStatus = {
        pending: 'sent',
        sent: 'confirmed',
      };
      const next = nextStatus[props.smsStatus];
      if (next) {
        emit('status-change', next);
      }
    }

    function handleReset() {
      emit('status-change', 'pending');
    }

    return {
      handleClick,
      handleReset,
      isAdmin,
      statusClass,
      statusText,
    };
  },
};
</script>

<style lang="scss" scoped>
.sms-status-container {
  display: flex;
  gap: 5px;
  align-items: center;
}

.sms-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #17a2b8;
  color: white;
  font-size: 10px;
}

.sms-icon-confirmed {
  background-color: #28a745;
}

.sms-btn {
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 8px;
  transition: ease-out 0.1s;
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:active:not(:disabled) {
    transform: scale(0.95);
  }
}

.sms-pending {
  background-color: #ffc107;
  color: #212529;
}

.sms-sent {
  background-color: #28a745;
}

.reset-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: #dc3545;
  border: none;
  border-radius: 50%;
  color: white;
  cursor: pointer;
  font-size: 10px;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:hover:not(:disabled) {
    background-color: #c82333;
  }
}
</style>
